var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',{staticClass:"sedna_form_vcenter",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('b-row',{staticStyle:{"width":"100%"},attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"lg":"5","md":"10","sm":"12"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }